import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie } from 'lucide-react';
import Button from './Button';
import { initMetaPixel } from '../../utils/metaPixel';

const STORAGE_KEY = 'ta_consent_v1';

/** 'granted' | 'denied' | null */
export function getConsent() {
  try { return localStorage.getItem(STORAGE_KEY); } catch (_) { return null; }
}

// GDPR: marketing cookies are opt-in, so the pixel stays unloaded until the
// visitor actively accepts. Declining is one click and is remembered.
function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const choice = getConsent();
    if (choice === 'granted') initMetaPixel();
    else if (choice !== 'denied') setVisible(true);
  }, []);

  const decide = (choice) => {
    try { localStorage.setItem(STORAGE_KEY, choice); } catch (_) {}
    if (choice === 'granted') initMetaPixel();
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', damping: 24, stiffness: 260 }}
          role="dialog"
          aria-label="Cookie consent"
          className="fixed bottom-0 inset-x-0 z-[9999] p-3 sm:p-4"
        >
          <div className="mx-auto max-w-3xl bg-white rounded-2xl shadow-xl border border-platinum-300 p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-4">
            <Cookie size={22} className="text-coral-400 shrink-0 hidden sm:block" />
            <p className="text-sm text-charcoal-400 flex-1">
              We use analytics and advertising cookies to understand how the site is
              used and to measure our ads. Nothing loads until you choose.
            </p>
            <div className="flex gap-2 shrink-0">
              <Button variant="ghost" size="sm" onClick={() => decide('denied')}>
                Decline
              </Button>
              <Button variant="primary" size="sm" onClick={() => decide('granted')}>
                Accept
              </Button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default CookieConsent;
